export const ACCOUNT_TYPE = 'ACCOUNT_TYPE'
export const SET_REG_NUM = 'SET_REG_NUM'
export const SET_COM_NAME = 'SET_COM_NAME'
export const SET_ADDRESS = 'SET_ADDRESS'
export const SET_CONTACT = 'SET_CONTACT'
export const SET_CONTACT_EMAIL = 'SET_CONTACT_EMAIL'
export const SET_CONTRACT = 'SET_CONTRACT'
export const SET_ATTACHMENT = 'SET_ATTACHMENT'
export const SET_FULL_NAME = 'SET_FULL_NAME'
export const SET_POSITION = 'SET_POSITION'
export const SET_PHONE = 'SET_PHONE'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_REFERRAL = 'SET_REFERRAL'
export const SET_FIRST_NAME = 'SET_FIRST_NAME'
export const SET_LAST_NAME = 'SET_LAST_NAME'
export const RESET_ACCOUNT_FIELDS = 'RESET_ACCOUNT_FIELDS'

export const setAccount = payload => dispatch =>
  dispatch({
    type: ACCOUNT_TYPE,
    payload: payload
  })
export const setRegistrationNum = payload => dispatch =>
  dispatch({
    type: SET_REG_NUM,
    payload: payload
  })
export const setCompanyName = payload => dispatch =>
  dispatch({
    type: SET_COM_NAME,
    payload: payload
  })
export const setAddress = payload => dispatch =>
  dispatch({
    type: SET_ADDRESS,
    payload: payload
  })
export const setContact = payload => dispatch =>
  dispatch({
    type: SET_CONTACT,
    payload: payload
  })
export const setContactEmail = payload => dispatch =>
  dispatch({
    type: SET_CONTACT_EMAIL,
    payload: payload
  })
export const setContract = payload => dispatch =>
  dispatch({
    type: SET_CONTRACT,
    payload: payload
  })
export const setAttachment = payload => dispatch =>
  dispatch({
    type: SET_ATTACHMENT,
    payload: payload
  })
export const setFullName = payload => dispatch =>
  dispatch({
    type: SET_FULL_NAME,
    payload: payload
  })
export const setPosition = payload => dispatch =>
  dispatch({
    type: SET_POSITION,
    payload: payload
  })
export const setPhoneNumber = payload => dispatch =>
  dispatch({
    type: SET_PHONE,
    payload: payload
  })
export const setEmail = payload => dispatch =>
  dispatch({
    type: SET_EMAIL,
    payload: payload
  })
export const setReferral = payload => dispatch =>
  dispatch({
    type: SET_REFERRAL,
    payload: payload
  })
export const setFirstName = payload => dispatch =>
  dispatch({
    type: SET_FIRST_NAME,
    payload: payload
  })
export const setLastName = payload => dispatch =>
  dispatch({
    type: SET_LAST_NAME,
    payload: payload
  })
export const resetAccountFields = payload => dispatch =>
  dispatch({
    type: RESET_ACCOUNT_FIELDS,
    payload: payload
  })
